import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CommissionConfigComponent } from './commission-config.component';
import { UpdateCommissionConfigComponent } from './update-commission-config/update-commission-config.component';
import { CreateCommissionConfigComponent } from './create-commission-config/create-commission-config.component';
import { ViewCommissionConfigComponent } from './view-commission-config/view-commission-config.component';
import { AuthGuardService } from 'src/app/shared/auth-guard.service';


const routes: Routes = [

	{
		path: '', component: CommissionConfigComponent, 
		children: [

			{ path: 'create-commission-config', component: CreateCommissionConfigComponent, canActivate:[AuthGuardService] },
			{ path: 'update-commission-config/:id', component: UpdateCommissionConfigComponent, canActivate:[AuthGuardService] },
			{ path: 'view-commission-config', component: ViewCommissionConfigComponent, canActivate:[AuthGuardService], },

			// {
			// 	path: '',
			// 	redirectTo: 'create-client',
			// 	pathMatch: 'full'
			// }
		]
	},

];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class CostCenterRoutingModule { }
